// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605060616/js/" + chunkId + "." + {"44":"fc460304","225":"cf495dbc","481":"3c39beef","486":"78fb967f","770":"71c7bdc8"}[chunkId] + ".0.26502142808399354.chunk.js";
};